import { api } from "api";

export function usePollingNotifications() {
  const { data = {} } = api.endpoints.updates.useQuery(undefined, {
    pollingInterval: 5000,
  });

  return data;
}
